import { createEntityAdapter } from '@reduxjs/toolkit';
import { getSensorUniqueKey } from '@utils/sensors/sensors.utils';

import { PerimeterCamera } from '@/types/sensor/sensors/perimeterCamera.types';

export const perimeterCamerasAdapter = createEntityAdapter<PerimeterCamera, string>({
  selectId: getSensorUniqueKey,
  sortComparer: (objectA, objectB) => getSensorUniqueKey(objectA).localeCompare(getSensorUniqueKey(objectB)),
});
